import { render, staticRenderFns } from "./PaymentMethodSelection.vue?vue&type=template&id=70d7fa18&scoped=true"
import script from "./PaymentMethodSelection.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelection.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodSelection.vue?vue&type=style&index=0&id=70d7fa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7fa18",
  null
  
)

export default component.exports